import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const impressionsResolver: FieldResolver = (metadata: Metadata) =>
  ({ impressions: metadata.getImpressions() } as StreamData)

export default impressionsResolver
